import { ErrorPage } from '@zg-rentals/visual-cohesion';
import { EXTERNAL_URLS, URLS } from '../constants/urls';

export function ServerErrorPage() {
  return (
    <ErrorPage
      errorMessage="Something went wrong on our end"
      errorDetails="Try refreshing the page. If that doesn’t work, check back in a few minutes."
      action={<a href={EXTERNAL_URLS.RENTAL_MANAGER}>Go to Rental Manager</a>}
      secondaryAction={<a href={URLS.FAQS}>Contact support</a>}
    />
  );
}

export default ServerErrorPage;
